export default {
    url: '/privacy',
    template: '<manage-settings-privacy company="vm.company"></manage-settings-privacy>',
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManagePrivacySettings();
        }
    },
    resolve: {
        company (CompanyResource, TokenService) {
            return CompanyResource.get({ id: TokenService.getCompanyId(), expand: 'languages' }).$promise;
        }
    },
    controller (company) {
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/privacy/index.js